// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2b457ca5","453":"54292a4b","874":"8383629f"}[chunkId] + ".chunk.js";
};